<template>
    <div class="container">
        <div class="title-box">
            <h1 class="title-text">当サイト掲載専門業者の</h1>
        </div>
        <div class="selection-criteria-box">
            <span class="number">3</span>
            <span class="text-and-criteria-wrapper">
                <span class="text">つの</span>
                <span class="criteria-text">選定基準</span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GutterDesign',
};
</script>

<style scoped>
.container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; /* 中央寄せ */
    background: #0a51ae;
    padding: 20px 10px; /* 上下の余白を詰める */
    margin-bottom: 20px;
}

/* ▼ 下矢印 */
.container::after {
    content: "";
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 20px solid #0a51ae;
}

.title-box {
    color: white;
}

.title-text {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
    letter-spacing: 2px;
}

.selection-criteria-box {
    display: flex;
    align-items: center; /* baseline → center で縦位置を揃える */
    color: white;
    margin-top: -5px; /* 余白削除 */
}

.number {
    font-size: 3rem; /* 少し小さめに */
    font-weight: bold;
    color: #ffc107;
    line-height: 1;
    margin-right: 6px; /* 数字と文字の間隔 */
}

.criteria-text {
    font-size: 1.6rem;
    font-weight: bold;
    color: #ffc107;
    line-height: 1;
}

.text-and-criteria-wrapper {
    display: flex;
    align-items: center;
}

.text {
    font-size: 1.6rem;
    font-weight: bold;
    color: white;
    margin-right: 4px;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .title-text {
        font-size: 1.6rem;
    }

    .text {
        font-size: 1.4rem;
    }

    .criteria-text {
        font-size: 1.5rem;
    }

    .number {
        font-size: 2.5rem;
    }
}

@media (max-width: 480px) {
    .title-text {
        font-size: 1.4rem;
    }

    .text {
        font-size: 1.4rem;
    }

    .criteria-text {
        font-size: 1.6rem;
    }

    .number {
        font-size: 3rem;
    }
}
</style>
